import React from 'react';
import { InputTextarea } from 'primereact/inputtextarea';
import { Button } from 'primereact/button';
import 'primereact/resources/themes/lara-light-indigo/theme.css';
import 'primereact/resources/primereact.min.css';
import 'primeicons/primeicons.css';
import { ProgressSpinner } from 'primereact/progressspinner';

function CompInput({
  setvalbarcode,
  valbarcode,
  preview,
  download_file,
  updatedatabase,
  loadupdate,
  loadresponse,
}) {
  return (
    <div className='bg-white rounddash'>
      <div>
        <h2 className='text-xl font-bold text-left'>Masukan Barcode :</h2>
      </div>
      <div className='mt-3 text-left'>
        <InputTextarea
          className='w-full'
          value={valbarcode}
          onChange={(e) => setvalbarcode(e.target.value)}
          rows={25}
          cols={50}
        />
      </div>
      <div className='grid grid-cols-4 gap-2 h-full'>
        <Button
          className='col-span-2'
          label='Preview'
          size='small'
          onClick={preview}
        />
        <Button
          className='col-span-2'
          label='Save to Excel'
          size='small'
          onClick={download_file}
        />
        <Button
          className='col-span-2'
          label='Refresh Database'
          size='small'
          onClick={updatedatabase}
        />

        {loadupdate === true && (
          <ProgressSpinner
            className='col-span-2'
            style={{ width: '40px', height: '40px' }}
            strokeWidth='8'
            animationDuration='.5s'
          />
        )}
        <div className='col-span-4'>
          <h2 className='text-xs font-bold text-left'>{loadresponse}</h2>
        </div>
      </div>
    </div>
  );
}

export default CompInput;
